<template>
  <div class="MenuBar" :class="{ 'scrolled': isScrolled }">
    <!-- 导航链接 -->
    <nav class="nav">
      <!-- 新增logo -->
      <div class="logo">
        <img src="../assets/images/SPG-logo.svg" @click="$router.push('/')"  alt="SPG Logo">
      </div>
      <div class="menuBarList">
        <div v-for="(item, index) in menuItems" :key="index" class="menu-item">
          <!-- 有二级菜单的项 -->
          <div v-if="item.children && item.children.length" class="has-submenu">
            
              <router-link 
                :to="item.path"
                :title="item.name"
                :class="[
                  'menu-link', 
                  { 'router-link-exact-active': isParentRouteActive(item.path) }
                ]"
                :exact="false"
              >
                {{ item.name }}
                <i class="dropdown-icon">▼</i>
              </router-link>
              
              <!-- 二级菜单 -->
              <div class="submenu-b">
                <div class="icon-point"></div>
                <div class="submenu">
                <router-link 
                  v-for="child in item.children" 
                  :key="child.name"
                  :title="item.name"
                  :to="{ 
                    path: child.path, 
                    ...(child.anchor ? { hash: `#/${child.anchor}` } : {}) 
                  }"
                  :active-class="'router-link-exact-active'"
                  class="submenu-link"
                >
                  {{ child.name }}
                </router-link>
                </div>
              </div>
          </div>
          
          <!-- 没有二级菜单的项 -->
          <router-link 
            v-else
            :to="item.path"
            :title="item.name"
            :active-class="'router-link-exact-active'"
            :exact="item.exact !== undefined ? item.exact : true"
            class="menu-link"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
      <div class="topIconButton">
        <!-- <div class="top-icon" @click="goToTianmao" title="购买直通车"><i class="iconfont icon-gouwu" style="font-size: 30px;"></i></div> -->
        <!-- <div class="top-icon" @click="openTip('切换英文功能')" title="中英切换"><i class="iconfont icon-EN" style="font-size: 24px;"></i></div> -->
        <div class="top-icon" @click="handleSearchClick" title="站内搜索"><i class="iconfont icon-sousuo" style="font-size: 30px;"></i></div>
        <!-- <div class="top-icon" @click="openTip('切换繁体功能')" title="繁体切换"><i class="iconfont icon-fanti" style="font-size: 24px;"></i></div> -->

        <div class="language-selector" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <!-- 主图标按钮 -->
          <div class="language-trigger top-icon">
            <i class="iconfont icon-yuyanqiehuan1" style="font-size: 20px;"></i>
            <span class="current-language">{{ currentLanguageText }}</span>
          </div>
          
          <!-- 下拉菜单 -->
          <div class="language-dropdown" v-if="showDropdown">
          <!-- <div class="language-dropdown"> -->
            <div 
              class="language-option" 
              v-for="lang in languages" 
              :key="lang.code"
              @click.stop="handleLanguageChange(lang.code)"
            >
              {{ lang.name }}
            </div>
          </div>
        </div>

      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'  // 引入 Vuex 辅助函数
export default {
  data() {
    return {
      showDropdown: false,
      currentLanguage: 'zh-CN', // 默认简体中文
      languages: [
        { code: 'zh-CN', name: '中文简体' },
        { code: 'zh-TW', name: '中文繁体' },
        { code: 'en', name: '英文（EN）' }
      ],
      isScrolled: false,
      
      halfScreenHeight: 0
    };
  },
  watch: {
    // 监听路由的 hash 变化（更精准）
    '$route.hash'(newHash) {
      this.scrollToAnchor(newHash);
    }
  },
  computed: {
    ...mapState(['currentLang']),  // 映射全局语言状态
    menuItems() { 
      return [
        { path: '/', name: this.$t('menu.home') },  // 首页
        { 
          path: '/about',
          name: this.$t('menu.about'),  // 关于我们
          children: [
            { path: '/about', name: this.$t('menu.aboutGroup') },  // 集团介绍
            { path: '/about/corporateCulture', name: this.$t('menu.corporateCulture') },  // 品牌文化
            { path: '/about/brandHistory', name: this.$t('menu.brandHistory') },  // 品牌历程
            { path: '/about/brandPromotion', name: this.$t('menu.brandPromotion') },  // 品牌宣传
          ]
        },
        { path: '/news', name: this.$t('menu.news'),exact: false },
        { path: '/productShowcase', 
          name: this.$t('menu.productShowcase'),
          children: [
            { path: '/productShowcase/#chaye', name: this.$t('menu.teaSeries') }, 
            { path: '/productShowcase/#chayin', name: this.$t('menu.teaDrinkSeries') },
            { path: '/productShowcase/#chaqi', name: this.$t('menu.teaSetSeries') },
            { path: '/productShowcase/#chayan', name: this.$t('menu.teaBanquetSeries') },
            { path: '/productShowcase/#chacang', name: this.$t('menu.teaCabinSeries') }
          ]
        },
        { path: '/groupControl', name: this.$t('menu.groupControl') },
        { path: '/jobRecruitment', name: this.$t('menu.jobRecruitment') },
        { path: '/socialResponsibility', 
          name: this.$t('menu.socialResponsibility'),  // 社会责任
          children: [
            { path: '/socialResponsibility/publicWelfare', name: this.$t('menu.publicWelfare') },
            // { path: '/socialResponsibility/agricultureView', name: this.$t('menu.agricultureView') },
            // { path: '/socialResponsibility/villageView', name: this.$t('menu.villageView') },
            // { path: '/socialResponsibility/HealthyChina', name: this.$t('menu.healthyChina') }
          ]
        },
        { path: '/contact', name: this.$t('menu.contact') }  // 联系我们     
      ]
    },
    currentLanguageText() {
      // 获取当前语言的显示名称
      const lang = this.languages.find(item => item.code === this.currentLanguage)
      return lang ? lang.name : '语言'
    }
  },
  mounted() {
    // 初始加载时强制触发一次
    this.scrollToAnchor(this.$route.hash);
    // 兼容异步加载场景（如果内容是异步渲染的）
    this.$nextTick(() => {
      this.scrollToAnchor(this.$route.hash);
    });
    this.halfScreenHeight = window.innerHeight / 2;
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 点击搜索按钮，向父组件发送事件
    handleSearchClick() {
      // 触发自定义事件，通知父组件打开搜索弹窗
      this.$emit("open-search-dialog");
    },
    scrollToAnchor(hash) {
      if (!hash) return;

      const anchorId = hash.slice(1); // 提取 "chaye"
      // 调试：打印锚点 ID 和是否找到元素
      // console.log('锚点 ID:', anchorId);
      
      // 方法1：直接查找元素
      let element = document.getElementById(anchorId);
      
      // 方法2：如果元素是动态生成的，用 setTimeout 延迟查找（最坏情况）
      if (!element) {
        setTimeout(() => {
          element = document.getElementById(anchorId);
          if (element) this.scrollToElement(element);
          else console.error('未找到锚点元素:', anchorId);
        }, 100); // 延迟 100ms 再查
        return;
      }
      
      this.scrollToElement(element);
    },
    scrollToElement(element) {
      // 强制滚动到元素位置（禁用平滑滚动，排除动画问题）
      element.scrollIntoView({
        behavior: 'auto', // 先禁用平滑滚动，测试是否生效
        block: 'start' // 顶部对齐
      });
      // 调试：确认滚动执行
      // console.log('已滚动到元素:', element);
    },
    goToTianmao(){
      window.open
      window.open('https://sanpiguan.tmall.com/shop/view_shop.htm?spm=pc_detail.30350276.shop_block.dshopinfo.10d87dd6xeA9M6', "_blank");
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 100;
    },
    isParentRouteActive(parentPath) {
      const currentPath = this.$route.path;
      return currentPath.startsWith(parentPath);
    },
    handleLanguageChange(code) {
      this.currentLanguage = code
      // 这里添加实际的语言切换逻辑
      this.switchLanguage(code)
      this.$bus.$emit('languageChanged')
      // 关闭下拉菜单
      this.showDropdown = false
    },

    ...mapActions(['changeLang']),
    switchLanguage(code) {
      // 调用 action 并等待其完成（如果 action 是同步的，直接执行也可）
      this.changeLang(code).then(() => {
        // 语言切换成功后显示提示
        if (code === 'zh-TW') {
          this.$notify({
            title: '切換語言成功',
            message: '已為您切換至中文繁體模式',
            type: 'success'
          });
        } else if (code === 'en') {
          this.$notify({
            title: 'Switch language',
            message: 'We have switched to English mode for you',
            type: 'success'
          });
        } else {
          this.$notify({
            title: '切换语言成功',
            message: '已为您切换至中文简体模式',
            type: 'success'
          });
        }
      });
    },
    switchToEnglish() {
      this.$i18n.locale = 'en'; // 切换 i18n 语言
      document.documentElement.lang = 'en'; // 同步更新 html 的 lang 属性
    },
    switchToChinese() {
      this.$i18n.locale = 'zh-CN';
      document.documentElement.lang = 'zh-CN'; // 中文时同步
    },
    // switchLanguage(code) {
    //   this.$i18n.locale = code;
    //   this.currentLanguage = code;
    //   this.$notify({
    //     title: this.$t('message.langSwitchSuccess'),
    //     message: this.$t(`message.lang${
    //       code === 'zh-CN' ? 'Chinese' : 
    //       code === 'zh-TW' ? 'Taiwan' : 'English'
    //     }`),
    //     type: 'success'
    //   });
    //   console.log('切换到语言:', code);
    // },
    openTip(res){
      this.$alert(res+'建设中..敬请期待！', '消息', {
        confirmButtonText: '朕知道了',
        lockScroll: false,
        showClose: false
      });
    }
  }
};
</script>

<style scoped>
.menu-item {
  position: relative;
  margin: 0 10px;
}

.menu-link {
  display: inline-block;
  text-decoration: none;
  color: #333;
}

.dropdown-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
  display: inline-table;
}

.submenu-b {
  position: absolute;
  top: 100%;
  left: 0;
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s ease-out;
}
.submenu{
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 4px;
}

.menuBarList .menu-item .has-submenu .submenu-b .submenu .submenu-link:first-child{border-radius: 4px 4px 0 0;}
.menuBarList .menu-item .has-submenu .submenu-b .submenu .submenu-link:last-child{border-radius: 0 0 4px 4px;}

.has-submenu:hover .submenu-b {
  max-height: 332px;
  padding: 10px 0;
}

.submenu-link {
  display: block;
  padding: 8px 16px;
  text-decoration: none;
  color: #333;
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

.menuBarList .menu-item .has-submenu:hover .submenu-link {
  opacity: 1;
  transform: translateY(0);
}

.submenu-link:nth-child(1) { transition-delay: 0.3s; }
.submenu-link:nth-child(2) { transition-delay: 0.9s; }
.submenu-link:nth-child(3) { transition-delay: 1.2s; }

.submenu-link:hover {
  background-color: #f5f5f5;
}

.has-submenu:hover .dropdown-icon {
  transform: rotate(180deg);
}

.router-link-exact-active {
  color: #E60012;
  font-weight: 500;
}
.menuBarList .menu-item .submenu-b .submenu a:hover {
	color: #E60012;
}
.menuBarList .menu-item .submenu-b .submenu .router-link-exact-active{color: #E60012;}


/* 重点修改：调整菜单列表位置 */
.menuBarList {
	display: flex;
  /* 移除固定宽度，改为自适应 */
  flex: 1;
  /* 增加左侧间距，避免太靠左 */
  margin-left: 1rem;
	height: inherit;
	line-height: 80px;
  /* 让菜单项均匀分布 */
  justify-content: center;
}
.menuBarList .menu-item {
  max-width: 120px;
	padding: 0 5px;
	box-sizing: border-box;
	white-space: nowrap;
}
.menuBarList .menu-item a{
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden;    /* 隐藏超出部分 */
  text-overflow: ellipsis;
  display: block;
  text-transform: none;
}
.menuBarList .menu-item .submenu a{
  color: #303133;
  transition: all 300ms;
  line-height: 50px;
}
.topIconButton {
	display: flex;
  /* 调整图标区域宽度 */
  width: auto;
  padding-left: 1rem;
	height: inherit;
	line-height: 80px;
}
.top-icon {
	color: #e60012;
	margin: 0 8px;
  cursor: pointer;
}
.topIconButton .top-icon:last-child {
	margin-right: 0;
}
.top-icon i {
	font-size: 28px;
}
.MenuBar {
  background-color: transparent;
  box-shadow: none;
  padding: 0 5%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 12;
  transition: all 0.3s ease-in-out;
}

.MenuBar.scrolled {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.scrolled{
  border-bottom: none;
}
.scrolled .nav a{
  color: #303133;
}
.nav {
  max-width: 1400px;
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
  /* 调整整体间距 */
  gap: 1rem;
  transition: all 300ms;
}

.logo {
  /* 保留logo的左对齐，但不强制推到最左 */
  margin-right: 1rem;
  cursor: pointer;
}

.logo img {
  height: 50px;
  width: auto;
}

.nav a {
  color: #ffffff;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  transition: all 0.3s ease;
  line-height: 80px;
}
.icon-point{
  width: 100%;
  height: 12px;
}
.submenu-b::before{
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid rgba(255, 255, 255, 0.8);
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(2px);
}
.scrolled .nav a {
  color: #303133;
  transition: all 300ms;
} 
.nav a {
  color: #303133;
  transition: all 300ms;
}

.nav a.router-link-exact-active {
  color: #E60012;
  font-weight: 700;
  transition: all 300ms;
}

.nav a:hover {
  color: #E60012;
  transition: all 300ms;
  font-weight: 500;
}

.nav a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 3.5px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #ffffff;
  transition: all 300ms;
}

.nav a:hover::after,
.nav a.router-link-exact-active::after {
  width: 50%;
  background-color: #E60012;
  transition: all 300ms;
}
.nav .has-submenu a::after{
  transform: translateY(-2px);
}
/* .MenuBar  .nav .menuBarList .menu-item:first-child .menu-link::after{width: 80%;} */

@media (max-width: 768px) {
  .nav {
    height: auto;
    padding: 1rem 0;
    flex-wrap: wrap;
    gap: 1.5rem;
    justify-content: center;
  }
  
  .logo {
    margin: 0 auto 1rem;
    width: 100%;
    text-align: center;
  }
  
  .menuBarList {
    margin-left: 0;
    justify-content: center;
  }
}

.language-selector {
  width: 136px;
  position: relative;
  display: inline-block;
  margin-left: 10px; /* 根据需要调整位置 */
}

.language-trigger {
  
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  /* padding: 5px 10px; */
  border-radius: 4px;
  transition: background-color 0.2s;
}

.language-trigger:hover {
  /* background-color: rgba(0, 0, 0, 0.05); */
}

/* 语言图标 - 如果没有现成的可以用这个样式 */
.icon-language::before {
  content: '🌐'; /* 用地球图标作为默认 */
}

.current-language {
  font-size: 14px;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  left: 10px;
  min-width: 120px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 1000;
  /* overflow: hidden; */
}
.language-dropdown::before{
  content: '';
  width: 100%;
  height: 10px;
  position: absolute;
  top: -5px;
  left: 0;
}

.language-option {
  padding: 0px 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  text-align: left;
  line-height: 50px;
  transition: all 300ms;
}

.language-option:hover {
  background-color: #e600121a;
  color: #e60012;
  transition: all 300ms;
}

/* 可以添加一个分隔线区分当前选中项 */
.language-option.active {
  background-color: #e9f5ff;
  color: #1890ff;
}
</style>
